























import { Vue, Component, Prop } from 'vue-property-decorator';
import Input from '@/components/Input.vue';
import Button from '@/components/Button.vue';
import { IField } from '@/fields/types/field';

@Component({
  components: {
    Input,
    Button,
  },
})
export default class FieldSettingsContainer extends Vue {
  @Prop() field: IField;
  @Prop() height: string;
  @Prop({ default: true }) contentPadding: boolean;
  @Prop({ default: false }) enableScroll: boolean;
}
